import { render, staticRenderFns } from "./MemberCollection.vue?vue&type=template&id=eb846068&"
import script from "./MemberCollection.vue?vue&type=script&lang=ts&"
export * from "./MemberCollection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports